<div class="container" *ngIf="isLoaded" [@inOutAnimation]>
  <div class="container-inventory">
    <div class="header">
      <h1 class="title">{{'EDIT_PROFILE' | translate}}</h1>
      <app-back-arrow-settings [callback]="setListingUsers"></app-back-arrow-settings>
    </div>
      <div class="white-card">
        <div class="staff-container">
          <div class="member-container">
            <div>
              <p class="user-name">{{user.attributes.given_name + " " + user.attributes.family_name}}</p>
            </div>
            <div class="role-container">
              <p>{{user.attributes["custom:user_role"]}}</p>
            </div>
          </div>
          <div class="user-state">
            <p>{{'EMAIL' | translate}}:</p>
            <p class="state">{{user.attributes.email}}</p>
          </div>
          <div class="user-state">
            <p>{{'PHONE' | translate}}:</p>
            <p class="state" *ngIf="displayedPhoneNumber">{{displayedPhoneNumber}}</p>
          </div>
          <hr>
          <div class="alert-span-exeption">
            <span *ngIf="exceptionMessage != ''" [@inOutAnimation] class="error-message">{{exceptionMessage}}</span>
          </div>

        <form action="post" [formGroup]="editForm" (ngSubmit)="onEditUser()" *ngIf="isEditing">
            <div class="flex-row">
              <div class="form-group">
                <label for="firstname-input">{{'NAME' | translate}}</label>
                <input
                  type="text"
                  name="firstname-input"
                  class="textInput"
                  id="firstname-input"
                  formControlName="givenName"
                  (focus)="exceptionMessage = ''"

                >
                <div class="alert-span" *ngIf="editFormValidation['givenName'].touched && editFormValidation['givenName'].invalid">
                  <label class="error-message" *ngIf="editFormValidation['givenName'].errors && editFormValidation['givenName'].errors['required']">
                    {{'REQUIRED_FIELD' | translate}}
                  </label>
                  <label class="error-message" *ngIf="editFormValidation['givenName'].errors && (editFormValidation['givenName'].errors['pattern'] || editFormValidation['givenName'].errors['minlength'])">
                    {{ 'INVALID_NAME_FORMAT' | translate }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label for="lastname-input">{{'LAST_NAME' | translate}}</label>
                <input type="text" name="lastname-input" class="textInput" id="lastname-input" formControlName="familyName" (focus)="exceptionMessage = ''">
                <div class="alert-span" *ngIf="editFormValidation['familyName'].touched && editFormValidation['familyName'].invalid">
                  <label class="error-message" *ngIf="editFormValidation['familyName'].errors && editFormValidation['familyName'].errors['required']">
                    {{'REQUIRED_FIELD' | translate}}
                  </label>
                  <label class="error-message" *ngIf="editFormValidation['familyName'].errors && (editFormValidation['familyName'].errors['pattern'] || editFormValidation['familyName'].errors['minlength'])">
                    {{ 'INVALID_LAST_NAME_FORMAT' | translate }}
                  </label>
                </div>
              </div>
            </div>
            <div class="flex-row">
              <div class="form-group">
                <label for="phoneNumber-input">{{'PHONE' | translate}}</label>
                <input type="text" name="phoneNumber-input" class="textInput" id="phoneNumber-input" formControlName="phoneNumber" (focus)="exceptionMessage = ''">
                <div class="alert-span" *ngIf="editFormValidation['phoneNumber'].touched && editFormValidation['phoneNumber'].invalid">
                  <label class="error-message" *ngIf="editFormValidation['phoneNumber'].errors && (editFormValidation['phoneNumber'].errors['pattern'] || editFormValidation['phoneNumber'].errors['maxLength'])">
                    {{ 'INVALID_PHONE_FORMAT' | translate }}
                  </label>
                </div>
              </div>
            </div>
          <div class="form-buttons">
            <button class="edit" type="submit" [ngClass]="{'disabled': editForm.invalid || isSavingProfile}" [disabled]="editForm.invalid || isSavingProfile">{{'SAVE' | translate}}</button>
            <button class="cancel" type="button" (click)="toggleEditView()">{{'CANCEL' | translate}}</button>
          </div>
        </form>

        <form action="post" [formGroup]="passwordForm" (ngSubmit)="onUpdatePassword()" *ngIf="isChangingPassword">
            <div class="flex-row">
              <div class="form-group">
                <label for="user-password-input">{{'PASSWORD' | translate}}</label>
                <div class="password-input">
                  <input id="user-password-input" [type]="isPasswordVisible ? 'text':'password'" name="password" class="textInput" formControlName="oldPassword" (focus)="exceptionMessage = ''">
                  <i
                    class="password-icon"
                    [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"
                    (click)="isPasswordVisible = !isPasswordVisible"
                  ></i>
                </div>
                <div class="alert-span" *ngIf="passwordFormValidation['oldPassword'].touched && passwordFormValidation['oldPassword'].invalid">
                  <label class="error-message" *ngIf="passwordFormValidation['oldPassword'].errors && passwordFormValidation['oldPassword'].errors['required']">
                    {{'REQUIRED_FIELD' | translate}}
                  </label>
                  <label class="error-message" *ngIf="passwordFormValidation['oldPassword'].errors && (passwordFormValidation['oldPassword'].errors['pattern'] || passwordFormValidation['oldPassword'].errors['minlength'])">
                    {{ 'INVALID_PASSWORD_FORMAT' | translate }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label for="new-password-input">{{ 'NEW_PASSWORD' | translate }}</label>
                <div class="password-input">
                  <input id="new-password-input" [type]="isNewPasswordVisible ? 'text':'password'" name="password" class="textInput" formControlName="newPassword" (focus)="exceptionMessage = ''">
                  <i
                    class="password-icon"
                    [ngClass]="isNewPasswordVisible ? 'hide-password' : 'show-password'"
                    (click)="isNewPasswordVisible = !isNewPasswordVisible"
                  ></i>
                </div>
                <div class="alert-span" *ngIf="passwordFormValidation['newPassword'].touched && passwordFormValidation['newPassword'].invalid">
                  <label class="error-message" *ngIf="passwordFormValidation['newPassword'].errors && passwordFormValidation['newPassword'].errors['required']">
                    {{'REQUIRED_FIELD' | translate}}
                  </label>
                  <label class="error-message" *ngIf="passwordFormValidation['newPassword'].errors && (passwordFormValidation['newPassword'].errors['pattern'] || passwordFormValidation['newPassword'].errors['minlength'])">
                    {{ 'INVALID_PASSWORD_FORMAT' | translate }}
                  </label>
                </div>
              </div>

            </div>
          <div class="form-buttons">
            <button class="edit" type="submit" [ngClass]="{'disabled': passwordForm.invalid}" [disabled]="passwordForm.invalid">{{'SAVE' | translate}}</button>
            <button class="cancel" type="button" (click)="togglePasswordView()">{{'CANCEL' | translate}}</button>
          </div>
        </form>


        <div class="form-buttons" *ngIf="!isEditing && !isChangingPassword">
          <button class="submit-btn" type="button" (click)="toggleEditView()">{{'EDIT' | translate}}</button>
          <button class="submit-btn" type="button" (click)="togglePasswordView()">{{ 'CHANGE_PASSWORD' | translate }}</button>
        </div>
        </div>
      </div>
  </div>
</div>

